import Button from "../Button";
import { toast } from "sonner";
import { useState } from "react";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { useNavigate } from "react-router-dom";
import { api } from "../../taskpane/lib/api";
import { useUser } from "../../taskpane/components/auth-provider";

function ErrorComponent({ open, message = null, errorId = null }) {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { user } = useUser();

	const handleReport = async () => {
		setIsLoading(true);
		try {
			const data = {
				useremail: user.email,
				fullname: user.name,
				message: message.toString(),
			};
			const res: any = await api.post("/api/v1/auth/contact", data);

			if (res.success) {
				toast.success("Thank you for the feedback! ✌️");
				navigate("/");
			}
		} catch (err) {
			toast.error("Sorry😣, Try again!");
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div
			style={{
				height: "100vh",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				padding: "0.5rem",
			}}
		>
			{open && (
				<div
					style={{
						border: "2px solid #e3e3e3",
						borderRadius: "10px",
						padding: "1rem",
						color: "#646464",
						display: "flex",
						flexDirection: "column",
						gap: "1rem",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							color: "#0d0d2c",
							fontSize: "1.125rem",
							gap: "0.5rem",
						}}
					>
						<WarningRoundedIcon width={16} sx={{ color: "#ef4444" }} />
						Unexpected Issue
					</div>
					<div style={{ fontSize: "0.75rem" }}>
						We encountered an unexpected issue while processing your request. Please share the error{" "}
						{errorId ? (
							<span>
								<strong>{errorId}</strong>
							</span>
						) : (
							<span
								onClick={async () => {
									await navigator.clipboard.writeText(message);
									toast.success("Copied to Clipboard");
								}}
								style={{ color: "blue", cursor: "pointer" }}
							>
								Copy Error
							</span>
						)}{" "}
						with our support team to help us resolve this issue quickly
					</div>
					<Button variant="danger" onClick={() => handleReport()} loading={isLoading}>
						Report
					</Button>
				</div>
			)}
		</div>
	);
}

export default ErrorComponent;
